// extracted by mini-css-extract-plugin
export default {"flex-column":"gallery_flex-column__IGgTA","flex-row":"gallery_flex-row__LYGx8","gallery":"gallery_gallery__O5Z9U","page-size":"gallery_page-size__4v7en"};